import { Directive, ElementRef, AfterContentChecked, inject } from '@angular/core';

@Directive({
  selector: '[appAutoExpand]',
  standalone: false,
})
export class AutoExpandDirective implements AfterContentChecked {
  element = inject(ElementRef);

  ngAfterContentChecked(): void {
    this.adjust();
  }

  adjust(): void {
    this.element.nativeElement.style.overflow = 'hidden';
    this.element.nativeElement.style.height = null;
    this.element.nativeElement.style.height = this.element.nativeElement.scrollHeight + 'px';
  }
}
